import React from "react";
import {Row, Col} from "antd";
import CallToAction from "../../components/Landing/CallToAction";
import CredentialsForm from "../../components/Landing/CredentialsForm";
import Contacts from "../../components/Landing/Contacts";
import Team from "../../components/Landing/Team";
import Feedbacks from "../../components/Landing/Feedbacks";
import Partners from "../../components/Landing/Partners";
import Footer from "../../components/Landing/Footer";
import styles from './index.module.scss';

const Landing = () => {
  return (
    <div>
      <Row className={styles.landingRowDark}>
        <Col xs={24}>
          <CallToAction />
        </Col>
      </Row>
      <Row className={styles.landingRowLight}>
        <Col
          xs={24}
          id="compila-il-form"
          className={styles.landingFormCol}
        >
          <CredentialsForm />
        </Col>
      </Row>
      <Row className={styles.landingRowDark}>
        <Col xs={24}>
          <Contacts />
        </Col>
      </Row>
      <Row className={styles.landingRowLight}>
        <Col xs={24}>
          <Team />
        </Col>
      </Row>
      <Row className={styles.landingRowDark}>
        <Col xs={24}>
          <Feedbacks />
        </Col>
      </Row>
      <Row className={styles.landingRowWhite}>
        <Col xs={24}>
          <Partners />
        </Col>
      </Row>
      <Row className={styles.landingRowDark}>
        <Col xs={24}>
          <Footer />
        </Col>
      </Row>
    </div>
  )
}

export default Landing;